import { nanoid } from 'nanoid';
import React from 'react';

export default function Input({
  title,
  placeholder,
  value,
  type = 'text',
  onChange = () => {},
  attrs,
}: {
  title: string;
  placeholder: string;
  value?: any;
  type?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  attrs?: any;
}) {
  const id = nanoid();
  return (
    <div className="w-full text-[#53586C]">
      <label htmlFor={id} className="font-medium">
        {title}
      </label>
      <input
        id={id}
        className="h-10 w-full border border-[#53586C] rounded py-3 px-4 placeholder:text-gray-700/70 mt-3"
        placeholder={placeholder}
        value={value}
        type={type}
        onChange={onChange}
        {...attrs}
      />
    </div>
  );
}
